<template>
  <div>
    <b-container fluid class="p-0">
      <main>
        <CommonTitle :titleProps="'業務報告書と請求書の送信・発送'" />
        <!-- コンテンツ領域 -->
        <b-row class="pl-0 pr-2 pt-0 m-0">
          <b-col cols="12" class="w-100 p-0">
            <p class="m-0 small">発送の場合は印刷後、手動で発送処理を行います。発送が完了したら『請求書送付状況』を『発送済』にしてください。</p>
          </b-col>
        </b-row>
        <b-card>
        <validation-observer ref="validationObserver">
          <b-collapse id="open-form" v-model="visible" class="mb-3">
              <b-row class="m-0 p-0">
                <b-col cols="3" class="m-0 py-1 pl-0 pr-1">
                  <b-input-group-append size="sm" class="mr-2 d-flex align-items-center">
                    <p class="fs-12-bold filter-label">TAS ID</p>
                  </b-input-group-append>
                  <validation-provider name="TAS ID" :rules="{ max: 100 }" v-slot="validationContext">
                    <b-form-input
                      type="text"
                      class="rounded-left"
                      v-model="searchTextTasId"
                      :state="getValidationState(validationContext)"
                      aria-describedby="input-1-live-feedback"/>
                    <b-form-invalid-feedback class="ml-2 mr-2" id="input-1-live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                  </validation-provider>
                </b-col>
                <b-col cols="3" class="m-0 p-1">
                  <b-input-group-append size="sm" class="mr-2 d-flex align-items-center">
                    <p class="fs-12-bold filter-label">状況</p>
                  </b-input-group-append>
                  <b-form-select class="rounded-left" v-model="selectedStatus" :options="statusOptions" />
                </b-col>
                <b-col cols="3" class="m-0 p-1">
                  <b-input-group-append size="sm" class="mr-2 d-flex align-items-center">
                    <p class="fs-12-bold filter-label">支払方法</p>
                  </b-input-group-append>
                  <b-form-select class="rounded-left" v-model="selectedPaymentMethod" :options="paymentMethodOption" />
                </b-col>
                <b-col cols="3" class="m-0 p-1">
                  <b-input-group-append size="sm" class="mr-2 d-flex align-items-center">
                    <p class="fs-12-bold filter-label">担当プロジェクト</p>
                  </b-input-group-append>
                  <b-form-select class="rounded-left" v-model="selectedProject" :options="assumeProjectOption" />
                </b-col>
              </b-row>
              <b-row class="m-0 p-0 filter-group">
                <b-col cols="3" class="w-100 py-1 pl-0 pr-1">
                  <p class="fs-12-bold filter-label">請求書発行月</p>
                  <validation-observer vid="service_start_year_month" v-slot="validationContext">
                    <div class="box-input-ranger">
                      <div class="content-input">
                        <div class="input-date">
                          <validation-provider
                            class="m-0"
                            name="開始年月"
                            :rules="{
                                validityStateCheck: $refs['from-invoice-issuance-month'] ? {
                                  target: $refs['from-invoice-issuance-month']
                                } : false,
                                monthCheck: true,
                              }"
                            ref="fromInvoiceIssuanceMonth"
                            v-slot="validationContext"
                          >
                            <b-form-input
                              type="month"
                              max="9999-12"
                              v-model="fromInvoiceIssuanceMonth"
                              :state="getValidationState(validationContext)"
                              aria-describedby="input-from-invoice-issuance-month-live-feedback"
                              ref="from-invoice-issuance-month"
                            />
                            <b-form-invalid-feedback
                              id="input-dateFromTo2-live-feedback-from"
                            >
                              {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                          </validation-provider>
                        </div>
                        <div class="icon-space">
                          <div class="align-middle">〜</div>
                        </div>
                        <div class="input-date">
                          <validation-provider
                            class="m-0"
                            name="終了年月"
                            :rules="{
                                validityStateCheck: $refs['to-invoice-issuance-month'] ? {
                                  target: $refs['to-invoice-issuance-month']
                                } : false,
                                monthCheck: true,
                                dateDiffCheckOrSameMonth: {
                                  start: fromInvoiceIssuanceMonth,
                                  end: toInvoiceIssuanceMonth
                                }
                              }"
                            ref="toInvoiceIssuanceMonth"
                            v-slot="validationContext"
                          >
                            <b-form-input
                              type="month"
                              max="9999-12"
                              v-model="toInvoiceIssuanceMonth"
                              :state="getValidationState(validationContext)"
                              aria-describedby="input-3-live-feedback"
                              ref="to-invoice-issuance-month"
                            />
                            <b-form-invalid-feedback
                              id="input-dateFromTo2-live-feedback-to"
                            >
                              {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                          </validation-provider>
                        </div>
                      </div>
                      <div class="icon-clear" @click="invoiceIssuanceMonthClear" >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                          <g id="Group_1089" data-name="Group 1089" transform="translate(-1046 -235)">
                            <rect id="Rectangle_370" data-name="Rectangle 370" width="16" height="16" rx="8" transform="translate(1046 235)" fill="#eceff2"/>
                          </g>
                          <g id="Group_1091" data-name="Group 1091" transform="translate(-500 -440)">
                            <line id="Line_176" data-name="Line 176" x2="8" transform="translate(505.172 445.171) rotate(45)" fill="none" stroke="#3c3c3c" stroke-linecap="round" stroke-width="1"/>
                            <g id="Group_1090" data-name="Group 1090" transform="translate(465.574 -228.701) rotate(45)">
                              <line id="Line_177" data-name="Line 177" x2="8" transform="translate(508.5 444.5) rotate(90)" fill="none" stroke="#3c3c3c" stroke-linecap="round" stroke-width="1"/>
                            </g>
                          </g>
                        </svg>
                      </div>
                    </div>
                  </validation-observer>
                </b-col>
                <b-col cols="3" class="m-0 p-1">
                  <b-input-group-append size="sm" class="mr-2 d-flex align-items-center">
                    <p class="fs-12-bold filter-label">合計金額</p>
                  </b-input-group-append>
                  <validation-provider name="合計金額" :rules="{ hankakuNumberSymbol: true }" v-slot="validationContext">
                    <b-form-input
                      type="text"
                      class="rounded-left"
                      v-model="amountBilledTotal"
                      :state="getValidationState(validationContext)"
                      aria-describedby="input-from-amount-billed-total-live-feedback"/>
                    <b-form-invalid-feedback class="ml-2 mr-2" id="input-from-amount-billed-total-live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                  </validation-provider>
                </b-col>
              </b-row>
          </b-collapse>
          <div class="p-0 m-0 d-flex flex-wrap justify-content-between align-items-end">
            <div @click="visible = !visible" class="cursor-pointer fs-14-bold">
              <div v-if="visible">
                閉じる <font-awesome-icon icon="chevron-up" />
              </div>
              <div v-if="!visible">
                詳細検索 <font-awesome-icon icon="chevron-down" />
              </div>
            </div>
            <div>
                <b-button size="sm" class="with-btn" pill variant="outline-secondary" @click="searchItemClear">検索項目をクリア</b-button>
                <b-button size="sm" class="with-btn ml-3 btn-under-2-char" pill variant="primary" type="submit" @click="load">検索</b-button>
            </div>
          </div>
        </validation-observer>
        </b-card>
        <b-card class="mt-3">
          <b-row>
            <b-col cols="12">
              <b-row>
                <b-col :cols="getResponsiveColumns(2)" class="text-center ml-2 pl-1 mb-3">
                  <b-button variant="primary" class="custom-width" :disabled="isShippingUploadDisabled" size="sm" v-b-modal.modal-shipping-upload>選択した顧客の請求書などの<br>アップロード・FAX送信・印刷</b-button>
                </b-col>
                <b-col :cols="getResponsiveColumns(2)" class="text-center ml-2 pl-1 mb-3">
                  <b-button variant="primary" class="custom-width" :disabled="isShippingMailDisabled" size="sm" v-b-modal.modal-shipping-mail>選択した顧客の<br>郵送の請求書の発送を完了</b-button>
                </b-col>
                <b-col :cols="getResponsiveColumns(2)" class="text-center ml-2 pl-1 mb-3">
                  <b-button variant="primary" class="custom-width" :disabled="isShippingPaymentDisabled" size="sm" v-b-modal.modal-shipping-payment>請求済の<br>顧客の決済処理を開始</b-button>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12">
              <b-row>
                <b-col :cols="getResponsiveColumns(2)" class="text-center ml-2 pl-1 mb-3">
                  <b-button class="custom-width" variant="danger" :disabled="isShippingResetDisabled" size="sm" v-b-modal.modal-shipping-reset>選択した顧客の各状況を<br>リセットする</b-button>
                </b-col>
                <b-col :cols="getResponsiveColumns(2)" class="text-center ml-2 pl-1 mb-3">
                  <b-button class=" custom-width" variant="danger" :disabled="isShippingResetDisabled" size="sm" v-b-modal.modal-shipping-reset-no-contact>選択した顧客の各状況を<br>リセットする（顧客連絡なし）</b-button>
                </b-col>
                <b-col :cols="getResponsiveColumns(2)" class="text-center ml-2 pl-1 mb-3">
                  <b-button variant="danger" size="sm" :disabled="isShippingCompletedDisabled" class=" custom-width" v-b-modal.modal-shipping-completed>選択した顧客を完了にする</b-button>
                </b-col>
                <b-col :cols="getResponsiveColumns(2)" class="text-center ml-2 pl-1 mb-3">
                  <b-button variant="danger" size="sm" :disabled="isShippingBilledDisabled" class=" custom-width" v-b-modal.modal-shipping-billed>選択した顧客を請求済にする</b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="p-0 m-0 d-flex justify-content-between mb-2">
            <div>
              <b-row class="m-0 p-0" align-v="center">
                <b-col cols="auto p-0 m-0">
                  <b-button class="p-0 btn-download custom-select-sm pl-3 pr-3" variant="outline-primary" size="sm" @click="downloadCsv('business_report_and_invoice_delivery_target')">&nbsp;CSV出力&nbsp;</b-button>
                </b-col>
                <b-col cols="auto p-0 ml-2">
                  <b-form inline class="custom-select-sm p-0">
                    <b-form-checkbox v-model="checkAll"><b-form-text>全て選択</b-form-text></b-form-checkbox>
                  </b-form>
                </b-col>
                <b-col>
                  <CommonSelectAction :options="selectActions"/>
                </b-col>
              </b-row>
            </div>
            <div>
              <CommonPagination
                :listTotalRowCountProps="computedListTotalRowCount"
                :perPageProps="computedPerPage"
                :currentPageProps="computedCurrentPage"
                :is-show-page-options="false"
                @searchingAgain="pagingSearchingAgain"
                @changePerPage="onShowRowCountButtonClick"
              />
            </div>
          </b-row>
          <b-row class="p-0 m-0">
            <CommonColumnDragTable
              id="table_shipping_list"
              ref="selectableTable"
              v-model="fields"
              :items="computedItems"
              :selectable="true"
              :selectMode="'multi'"
              :hover="true"
              @rowClicked="onRowClicked"
              @sortChange="sortChanged"
            >
              <template v-slot:select="row">
                <b-form-checkbox v-model="row.selected" />
              </template>
              <!-- NOTE: 計上年月 -->
              <template v-slot:earmarking_year_month="row">
                <div v-for="(item, key) in row.earmarking_year_month_data" :key="key">
                  <p class="m-0" :class="key === 0 ? '' : 'mt-1'">{{ getEarmarkingYearMonthData(item) }}</p>
                </div>
              </template>
              <!-- NOTE: 合計金額 -->
              <template v-slot:amount_billed_total="row">
                {{ getAmountBilledTotal(row.amount_billed_total) }}
              </template>
              <!-- NOTE: 業務報告書送付状況 -->
              <template v-slot:business_report_send_status="row">
                {{ getOptionText(businessReportSendStatusOption, row.business_report_send_status) }}
              </template>
              <!-- NOTE: 請求書送付方法 -->
              <template v-slot:invoice_send_method_master_id="row">
                {{ getOptionText(invoiceSendMethodOption, row.invoice_send_method_master_id) }}
              </template>
              <!-- NOTE: 請求書送付状況 -->
              <template v-slot:invoice_send_status="row">
                {{ getOptionText(invoiceSendStatusOption, row.invoice_send_status) }}
              </template>
              <!-- NOTE: 支払い方法 -->
              <template v-slot:payment_method="row">
                {{ getOptionText(paymentMethodOption, row.payment_method) }}
              </template>
              <!-- NOTE: 総合状況 -->
              <template v-slot:invoice_status="row">
                {{ getOptionText(invoiceStatusOption, row.invoice_status) }}
              </template>
              <!-- NOTE: 担当プロジェクト -->
              <template v-slot:assume_project_id="row">
                {{ getOptionText(assumeProjectOption, row.assume_project_id) }}
              </template>
            </CommonColumnDragTable>
          </b-row>
          <b-row class="p-0 m-0 d-flex justify-content-between">
            <div>
              <b-row class="m-0 p-0" align-v="center">
                <b-col cols="auto p-0 m-0">
                  <b-button class="p-0 btn-download custom-select-sm pl-3 pr-3" variant="outline-primary" size="sm" @click="downloadCsv('business_report_and_invoice_delivery_target')">&nbsp;CSV出力&nbsp;</b-button>
                </b-col>
                <b-col cols="auto p-0 ml-2">
                  <b-form inline class="custom-select-sm p-0">
                    <b-form-checkbox v-model="checkAll"><b-form-text>全て選択</b-form-text></b-form-checkbox>
                  </b-form>
                </b-col>
                <b-col>
                  <CommonSelectAction :options="selectActions"/>
                </b-col>
              </b-row>
            </div>
            <div>
              <CommonPagination
                :listTotalRowCountProps="computedListTotalRowCount"
                :perPageProps="computedPerPage"
                :currentPageProps="computedCurrentPage"
                :is-show-page-options="false"
                @searchingAgain="pagingSearchingAgain"
                @changePerPage="onShowRowCountButtonClick"
              />
            </div>
          </b-row>
        </b-card>
      </main>
      <!-- 選択した顧客の請求書などのアップロード・FAX送信・印刷 -->
      <b-modal size="lg" id="modal-shipping-upload" no-close-on-backdrop no-close-on-esc centered content-class="customBtnClose" @close="suspendUploadShipping">
        <template #modal-header="{ close }">
          <CommonModalButtonClose @closeModal="close" />
        </template>
        <div class="fs-14-regular">
        <p>選択した顧客に対して、以下の処理を行います。(&nbsp;{{ selectItem.length }}件&nbsp;の顧客が選択されています)<br>
          よろしければ「実行」を押してください。<br>
          顧客にデータや書類を送信しますので十分ご確認の上、実行してください。</p>
        <ul>
          <li>業務報告書の送付が必要な顧客に、マイページへの業務報告書の アップロードとメールでのお知らせ。</li>
          <li>請求書の送付方法がメールの顧客に、マイページへのアップ ロードとメールでのお知らせ。</li>
          <li>請求書の送付方法がFAXの顧客に、請求書のFAX送信と、 マイページへのアップロード。</li>
          <li>請求書の送付方法が郵送の顧客用に、請求書の印刷と、 マイページへのアップロード。</li>
        </ul>
        <p>※別途発送処理を行う必要があります。</p>
        <p class="text-danger">（注）既に各処理が終わっている顧客には、選択されていても再送されません。</p>
        </div>
        <template v-slot:modal-footer="{ok, cancel}">
          <b-row class="w-100 m-auto align-content-center justify-content-center pb-1">
              <b-button size="sm" class="mr-3" pill variant="outline-secondary" @click="cancel">キャンセル</b-button>
              <b-button size="sm" class="btn-under-2-char" pill variant="primary" @click="ok(), shippingUpload()">実行</b-button>
          </b-row>
        </template>
      </b-modal>

      <!-- 送信モーダル -->
      <b-modal v-model="isUploadShipping" no-close-on-backdrop no-close-on-esc centered content-class="customBtnClose" @close="suspendUploadShipping">
        <template #modal-header="{ close }">
          <CommonModalButtonClose @closeModal="close" />
        </template>
        <span class="fs-14-regular">{{processingCount}}&nbsp;件 / {{selectItem.length}}&nbsp;件&nbsp;送信中...</span>
        <template v-slot:modal-footer>
          <div class="w-100 text-center">
            <b-button size="sm" class="btn-under-2-char" pill variant="primary" @click="suspendUploadShipping()">
              中断
            </b-button>
          </div>
        </template>
      </b-modal>

      <!-- 業務報告書と請求書の送信・印刷準備が完了 -->
      <b-modal v-model="isUploadShippingFinish" no-close-on-backdrop no-close-on-esc centered content-class="customBtnClose">
        <template #modal-header="{ close }">
          <CommonModalButtonClose @closeModal="close" />
        </template>
        <div class="fs-14-regular">
        <p>業務報告書と請求書の送信・印刷準備が完了しました。</p>
        <p class="m-0">郵送の請求書については、発送を行なった後、<br>
          請求書送付状況を「発送済」にしてください。</p>
        </div>
        <template v-slot:modal-footer="{ok}">
          <b-row class="w-100 m-auto align-content-center justify-content-between">
            <b-col cols="12" class="text-center">
              <b-button size="sm" class="btn-under-2-char" pill variant="primary" @click="ok(), getPageList()">OK</b-button>
            </b-col>
          </b-row>
        </template>
      </b-modal>

      <!-- 選択した顧客の郵送の請求書の発送を完了 -->
      <b-modal id="modal-shipping-mail" no-close-on-backdrop no-close-on-esc centered content-class="customBtnClose">
        <template #modal-header="{ close }">
          <CommonModalButtonClose @closeModal="close" />
        </template>
        <div class="fs-14-regular">
        <p>選択した印刷済の顧客の状況を発送済にします。(&nbsp;{{ selectItem.length }}件&nbsp;の顧客が選択されています)</p>
        <p>実際の発送処理は終わっていますか？</p>
        <p class="m-0 text-danger">※郵送、かつ「請求書送付状況」が「送付済」のもののみ処理を行います。</p>
        </div>
        <template v-slot:modal-footer="{ok, cancel}">
          <b-row class="w-100 m-auto align-content-center justify-content-center pb-1">
            <b-button size="sm" class="mr-3" pill variant="outline-secondary" @click="cancel">キャンセル</b-button>
            <b-button size="sm" class="btn-under-2-char" pill variant="primary" @click="ok(), shippingMail()">はい</b-button>
          </b-row>
        </template>
      </b-modal>

      <!-- 送信モーダル -->
      <b-modal v-model="isShippingMail" no-close-on-backdrop no-close-on-esc centered content-class="customBtnClose" @close="suspendMailShipping">
        <template #modal-header="{ close }">
          <CommonModalButtonClose @closeModal="close" />
        </template>
        <span class="fs-14-regular">{{ processingCount }}&nbsp;件&nbsp;/&nbsp;{{ selectItem.length }}&nbsp;件&nbsp;変更中...</span>
        <template v-slot:modal-footer>
          <div class="w-100 text-center">
            <b-button size="sm" class="btn-under-2-char" pill variant="primary" @click="suspendMailShipping()">
              中断
            </b-button>
          </div>
        </template>
      </b-modal>

      <!-- 選択した送付済の顧客の状況を「発送済」にし、総合状況が「請求済」 -->
      <b-modal v-model="isShippingMailFinish" okTitle="はい" no-close-on-backdrop no-close-on-esc centered content-class="customBtnClose">
        <template #modal-header="{ close }">
          <CommonModalButtonClose @closeModal="close" />
        </template>
        <p class="m-0 fs-14-regular">選択した送付済の顧客の状況を「発送済」にし、総合状況が「請求済」となりました。</p>
        <template v-slot:modal-footer="{ok}">
          <b-row class="w-100 m-auto align-content-center justify-content-between">
            <b-col cols="12" class="text-center">
              <b-button size="sm" class="btn-under-2-char" pill variant="primary" @click="ok(), getPageList()">はい</b-button>
            </b-col>
          </b-row>
        </template>
      </b-modal>

      <!-- 請求済の顧客の決済処理を開始 -->
      <b-modal id="modal-shipping-payment" no-close-on-backdrop no-close-on-esc centered content-class="customBtnClose">
        <template #modal-header="{ close }">
          <CommonModalButtonClose @closeModal="close" />
        </template>
        <div class="fs-14-regular">
        <p>総合状況が請求済になっている請求内容の決済を開始します。</p>
        <ul>
          <li>クレジットカード決済の場合、クレジット承認、 及び決済が即座に開始されます。</li>
          <p class="m-0 text-danger">※クレジットカード決済はキャンセル できませんのでご注意ください。</p>
          <li>口座振替の場合、振替伝票作成に進んでください。</li>
          <li>振込の場合、入金確認画面にて、振り込まれた金額を 入力してください。</li>
        </ul>
        <p class="m-0">よろしいですか？</p>
        </div>
        <template v-slot:modal-footer="{ok, cancel}">
          <b-row class="w-100 m-auto align-content-center justify-content-center pb-1">
            <b-button size="sm" class="mr-3" pill variant="outline-secondary" @click="cancel">キャンセル</b-button>
            <b-button size="sm" class="btn-under-2-char" pill variant="primary" @click="ok(), shippingPayment()">はい</b-button>
          </b-row>
        </template>
      </b-modal>

      <!-- 選択した顧客の各状況をリセットする -->
      <b-modal id="modal-shipping-reset" no-close-on-backdrop no-close-on-esc centered content-class="customBtnClose">
        <template #modal-header="{ close }">
          <CommonModalButtonClose @closeModal="close" />
        </template>
        <div class="fs-14-regular">
        <p>選択した顧客の請求処理をキャンセルします。(&nbsp;{{ selectItem.length }}件&nbsp;の顧客が選択されています)</p>
        <p class="m-0">顧客への連絡の必要がある処理なので、注意して実行してください。</p>
        </div>
        <template v-slot:modal-footer="{ok, cancel}">
          <b-row class="w-100 m-auto align-content-center justify-content-center pb-1">
            <b-button size="sm" class="mr-3" pill variant="outline-secondary" @click="cancel">キャンセル</b-button>
            <b-button size="sm" class="btn-under-2-char" pill variant="primary" @click="ok(), shippingReset(true)">実行</b-button>
          </b-row>
        </template>
      </b-modal>

      <!-- 選択した顧客の各状況をリセットする(顧客連絡なし) -->
      <b-modal id="modal-shipping-reset-no-contact" no-close-on-backdrop no-close-on-esc centered content-class="customBtnClose">
        <template #modal-header="{ close }">
          <CommonModalButtonClose @closeModal="close" />
        </template>
        <div class="fs-14-regular">
        <p>選択した顧客の請求処理をキャンセルします。(&nbsp;{{ selectItem.length }}件&nbsp;の顧客が選択されています)</p>
        <p class="m-0">顧客への連絡は行いません。</p>
        </div>
        <template v-slot:modal-footer="{ok, cancel}">
          <b-row class="w-100 m-auto align-content-center justify-content-center pb-1">
            <b-button size="sm" class="mr-3" pill variant="outline-secondary" @click="cancel">キャンセル</b-button>
            <b-button size="sm" class="btn-under-2-char" pill variant="primary" @click="ok(), shippingReset(false)">実行</b-button>
          </b-row>
        </template>
      </b-modal>

      <!-- 処理中 -->
      <b-modal v-model="isResetShipping" no-close-on-backdrop no-close-on-esc centered content-class="customBtnClose" @close="suspendResetShipping">
        <template #modal-header="{ close }">
          <CommonModalButtonClose @closeModal="close" />
        </template>
        <span class="fs-14-regular">{{processingCount}}&nbsp;件&nbsp;/&nbsp;{{selectItem.length}}&nbsp;件&nbsp;処理中...</span>
        <template v-slot:modal-footer>
          <div class="w-100 text-center">
            <b-button size="sm" class="btn-under-2-char" pill variant="primary" @click="suspendResetShipping()">
              中断
            </b-button>
          </div>
        </template>
      </b-modal>

      <!-- 請求処理をキャンセルし、マイページアップロードの顧客へはメールで、FAXの顧客はFAXでその旨の報告を送信 -->
      <b-modal v-model="isResetShippingFinish" okTitle="OK" no-close-on-backdrop no-close-on-esc centered content-class="customBtnClose">
        <template #modal-header="{ close }">
          <CommonModalButtonClose @closeModal="close" />
        </template>
        <div v-if="hasContactForReset" class="fs-14-regular">
          <p>請求処理をキャンセルし、マイページアップロードの顧客へはメールで、FAXの顧客はFAXでその旨の報告を送信しました。</p>
          <p class="m-0">郵送の顧客へはお知らせ分を作成しましたので、早急に印刷・郵送してください。</p>
        </div>
        <div v-else>
          <p class="fs-14-regular">請求処理をキャンセルしました。</p>
        </div>
        <template v-slot:modal-footer="{ok}">
          <b-row class="w-100 m-auto align-content-center justify-content-between">
            <b-col cols="12" class="text-center">
              <b-button size="sm" class="btn-under-2-char" pill variant="primary" @click="ok(), getPageList()">OK</b-button>
            </b-col>
          </b-row>
        </template>
      </b-modal>

      <!-- 現在選択中のリストを完了状態 -->
      <b-modal id="modal-shipping-completed" no-close-on-backdrop no-close-on-esc centered content-class="customBtnClose">
        <template #modal-header="{ close }">
          <CommonModalButtonClose @closeModal="close" />
        </template>
        <div class="fs-14-regular">
        <p>現在選択中のリストを完了状態にします。(&nbsp;{{ selectItem.length }}件&nbsp;の顧客が選択されています)</p>
        <p class="m-0">この作業は元に戻すことができません。<br>
          よろしいですか？</p>
        </div>
        <template v-slot:modal-footer="{ok, cancel}">
          <b-row class="w-100 m-auto align-content-center justify-content-center pb-1">
            <b-button size="sm" class="mr-3" pill variant="outline-secondary" @click="cancel">キャンセル</b-button>
            <b-button size="sm" class="btn-under-2-char" pill variant="primary" @click="ok(), onCompletedShipping()">はい</b-button>
          </b-row>
        </template>
      </b-modal>

      <!-- 送信中 -->
      <b-modal v-model="isShippingCompleted" no-close-on-backdrop no-close-on-esc centered content-class="customBtnClose" @close="suspendCompletedShipping">
        <template #modal-header="{ close }">
          <CommonModalButtonClose @closeModal="close" />
        </template>
        <span class="fs-14-regular">{{processingCount}}&nbsp;件 / {{selectItem.length}}&nbsp;件&nbsp;送信中...</span>
        <template v-slot:modal-footer>
          <div class="w-100 text-center">
            <b-button size="sm" class="btn-under-2-char" pill variant="primary" @click="suspendCompletedShipping()">
              中断
            </b-button>
          </div>
        </template>
      </b-modal>

      <!-- 選択中のリストを完了状態にしました。 -->
      <b-modal v-model="isCompletedShippingFinish" no-close-on-backdrop no-close-on-esc centered content-class="customBtnClose">
        <template #modal-header="{ close }">
          <CommonModalButtonClose @closeModal="close" />
        </template>
        <p class="m-0 fs-14-regular">選択中のリストを完了状態にしました。</p>
        <template v-slot:modal-footer="{ok}">
          <b-row class="w-100 m-auto align-content-center justify-content-between">
            <b-col cols="12" class="text-center">
              <b-button size="sm" class="btn-under-2-char" pill variant="primary" @click="ok(), getPageList()">OK</b-button>
            </b-col>
          </b-row>
        </template>
      </b-modal>

      <!-- 選択した顧客を請求済にする -->
      <b-modal size="lg" id="modal-shipping-billed" no-close-on-backdrop no-close-on-esc centered content-class="customBtnClose">
        <template #modal-header="{ close }">
          <CommonModalButtonClose @closeModal="close" />
        </template>
        <div class="fs-14-regular">
        <p>現在選択中のリストを請求済状態にします。(&nbsp;{{ selectItem.length }}件&nbsp;の顧客が選択されています)</p>
        <p class="m-0">この作業は元に戻すことができません。<br>
          よろしいですか？</p>
        </div>
        <template v-slot:modal-footer="{ok, cancel}">
          <b-row class="w-100 m-auto align-content-center justify-content-center pb-1">
            <b-button size="sm" class="mr-3" pill variant="outline-secondary" @click="cancel">キャンセル</b-button>
            <b-button size="sm" class="btn-under-2-char" pill variant="primary" @click="ok(), onBilledShipping()">はい</b-button>
          </b-row>
        </template>
      </b-modal>

      <!-- TODO:ここはいずれまとめたい;; -->
      <!-- 送信中 -->
      <b-modal v-model="isShippingBilled" no-close-on-backdrop no-close-on-esc centered content-class="customBtnClose" @close="suspendBilledShipping">
        <template #modal-header="{ close }">
          <CommonModalButtonClose @closeModal="close" />
        </template>
        <span class="fs-14-regular">{{processingCount}}&nbsp;件 / {{selectItem.length}}&nbsp;件&nbsp;送信中...</span>
        <template v-slot:modal-footer>
          <div class="w-100 text-center">
            <b-button size="sm" class="btn-under-2-char" pill variant="primary" @click="suspendBilledShipping()">
              中断
            </b-button>
          </div>
        </template>
      </b-modal>

      <!-- 選択中のリストを完了状態にしました。 -->
      <b-modal v-model="isCompletedBilledFinish" no-close-on-backdrop no-close-on-esc centered content-class="customBtnClose">
        <template #modal-header="{ close }">
          <CommonModalButtonClose @closeModal="close" />
        </template>
        <p class="m-0 fs-14-regular">選択中のリストを請求済状態にしました。</p>
        <template v-slot:modal-footer="{ok}">
          <b-row class="w-100 m-auto align-content-center justify-content-between">
            <b-col cols="12" class="text-center">
              <b-button size="sm" class="btn-under-2-char" pill variant="primary" @click="ok(), getPageList()">OK</b-button>
            </b-col>
          </b-row>
        </template>
      </b-modal>

      <!-- ローディングは文言によってモーダルを増やすのは良くないためまとめます -->
      <b-modal centered :title="isLoadingTxt" v-model="isLoading" hide-header hide-footer hide-header-close no-close-on-backdrop no-close-on-esc>
       <CommonLoader :title="isLoadingTxt"/>
      </b-modal>
      <!-- NOTE: validateチェックアラート -->
      <common-validate-check-alert
        @isValidAlertClose="alertClose"
        :isValidAlertProps="isValidAlert"
        :isValidAlertMessageProps="isValidAlertMessage"
      />
    </b-container>
  </div>
</template>

<script>

// NOTE: ローディングの共通文言を取得
import LoadingTxt from '../../../utils/loading-text-util'

// NOTE: カラムドラッグテーブルUI
import CommonColumnDragTable from '@/components/common/CommonColumnDragTable'

// NOTE: 共通ページネーションUI
import CommonPagination from '../../../components/common/CommonPagination'

// NOTE: 共通タイトルUI
import CommonTitle from '../../../components/common/CommonTitle'

// NOTE: トーストの共通文言を取得
import ToastTextUtil from '../../../utils/toast-text-util'

// NOTE: バリデートアラート表示コンポーネント
import CommonValidateCheckAlert from '../../../components/common/CommonValidateCheckAlert'
import CommonModalButtonClose from '@/components/common/CommonModalButtonClose.vue'
import CommonLoader from '@/components/common/CommonLoader.vue'
import CommonSelectAction from '@/components/common/CommonSelectAction.vue'

export default {
  components: {
    CommonLoader,
    CommonColumnDragTable,
    CommonPagination,
    CommonTitle,
    CommonValidateCheckAlert,
    CommonModalButtonClose,
    CommonSelectAction
  },
  data () {
    return {
      sortBy: 'invoice_made_year_month',
      sortDesc: true,
      isLoadingTxt: '',
      isLoading: false,
      businessReportSendStatusOption: [ // 業務報告書送付状況
        { value: 1, text: '未送付' },
        { value: 2, text: '送付済' },
        { value: 3, text: '送信エラー' },
        { value: 9, text: '送付不要' }
      ],
      invoiceSendStatusOption: [ // 請求書送付状況
        { value: 1, text: '未送付' },
        { value: 2, text: '送付済' },
        { value: 3, text: '発送済' },
        { value: 4, text: '送信エラー' },
        { value: 9, text: '送付不要' }
      ],
      paymentMethodOption: [ // 支払い方法
        { value: 0, text: '未設定' },
        { value: 1, text: '振込' },
        { value: 3, text: '口座振替' },
        { value: 4, text: 'クレジットカード（AMEX）' },
        { value: 5, text: 'クレジットカード（VISA）' },
        { value: 6, text: 'クレジットカード（その他）' }
      ],
      invoiceStatusOption: [ // 総合状況
        { value: 1, text: '未作成' },
        { value: 2, text: '作成済' },
        { value: 3, text: '承認依頼済' },
        { value: 4, text: '差戻' },
        { value: 5, text: '承認済（確認済）' },
        { value: 6, text: '伝票出力済' },
        { value: 7, text: '完了' },
        { value: 9, text: '作成不要' },
        { value: 10, text: '発送済' },
        { value: 11, text: '請求済' }
      ],
      invoiceSendMethodOption: [ // 支払い方法
        { value: 1, text: 'メール' },
        { value: 2, text: 'FAX' },
        { value: 3, text: '郵送（旧顧客用）' },
        { value: 4, text: 'その他（旧顧客用）' }
      ],
      assumeProjectOption: [ // 担当プロジェクト
      ],
      fields: [
        {
          key: 'select',
          label: '選択',
          variant: 'thead-primary'
        },
        {
          key: 'tas_id',
          label: 'TASID',
          sortable: true,
          variant: 'thead-primary'
        },
        {
          key: 'invoice_number',
          label: '請求番号',
          sortable: true,
          variant: 'thead-primary'
        },
        {
          key: 'corporate_name',
          label: '顧客名',
          sortable: true,
          variant: 'thead-primary'
        },
        {
          key: 'earmarking_year_month',
          label: '計上年月',
          sortable: true,
          variant: 'thead-primary',
          formatter: (value, key, item) => {
            try {
              return value.substring(0, 7)
            } catch (e) {
              return '0000-00'
            }
          }
        },
        {
          key: 'invoice_made_year_month',
          label: '請求書発行月',
          sortable: true,
          variant: 'thead-primary',
          sortDirection: 'desc',
          formatter: (value, key, item) => {
            try {
              return value.substring(0, 7)
            } catch (e) {
              return '0000-00'
            }
          }
        },
        {
          key: 'amount_billed_total',
          label: '合計金額',
          sortable: true
        },
        {
          key: 'business_report_send_status',
          label: '業務報告書送付状況',
          sortable: true,
          variant: 'thead-primary'
        },
        {
          key: 'invoice_send_method_master_id',
          label: '請求書送付方法',
          sortable: true,
          variant: 'thead-primary'
        },
        {
          key: 'invoice_send_status',
          label: '請求書送付状況',
          sortable: true,
          variant: 'thead-primary'
        },
        {
          key: 'payment_method',
          label: '支払方法',
          sortable: true,
          variant: 'thead-primary'
        },
        {
          key: 'invoice_status',
          label: '総合状況',
          sortable: true,
          variant: 'thead-primary'
        },
        {
          key: 'assume_project_id',
          label: '担当プロジェクト',
          sortable: true,
          variant: 'thead-primary'
        }
      ],
      items: [],
      allItems: [],
      compExcludeItems: [],
      currentPage: 1,
      listTotalRowCount: 0,
      approvalBackComment: '',
      isShippingMail: false,
      isShippingMailFinish: false,
      isSuspendMailShipping: false,
      isUploadShipping: false,
      isSuspendUploadShipping: false,
      isUploadShippingFinish: false,
      isResetShipping: false,
      isSuspendResetShipping: false,
      isResetShippingFinish: false,
      hasContactForReset: false,
      isChangePerPage: false,
      isChangeExclude: false,
      isChangeTargetDate: false,
      displayCurrentPage: 1,
      processingCount: 1,
      resetItemNumberList: [],
      isShippingPaymentDisabled: false,
      isShippingMailDisabled: false,
      selectedIndex: [],
      uploadShippingIds: [],
      isShippingCompleted: false,
      isCompletedShippingFinish: false,
      isSuspendShippingCompleted: false,
      firstPageUrl: null,
      lastPageUrl: null,
      nextPageUrl: null,
      prevPageUrl: null,
      urlParams: '',
      searchTextTasId: '',
      fromInvoiceIssuanceMonth: '',
      toInvoiceIssuanceMonth: '',
      selectedStatus: 5,
      selectedPaymentMethod: 0,
      selectedProject: 0,
      amountBilledTotal: '',
      statusOptions: [
        { value: 0, text: '未設定' },
        { value: 5, text: '承認済（確認済）' },
        { value: 6, text: '伝票出力済' },
        { value: 7, text: '完了' },
        { value: 9, text: '作成不要' },
        { value: 10, text: '発送済' },
        { value: 11, text: '請求済' }
      ],
      isShippingResetDisabled: true,
      isShippingUploadDisabled: true,
      isShippingCompletedDisabled: true,
      toastType: {
        error: 'error',
        warning: 'warning',
        info: 'info',
        success: 'success'
      },
      isValidAlert: false,
      isValidAlertMessage: [],
      perPageGroup: [20, 50, 100, 200, 300, 500, 1000, 1500, 2000, 2500, 3000, 3500],
      perPageGroupId: 0,
      checkAllFlag: false,
      paginationLimit: 10,
      isShippingBilled: false,
      isSuspendShippingBilled: false,
      isCompletedBilledFinish: false,
      isShippingBilledDisabled: false,
      selectItem: [],
      tmpSearchParams: {
        searchTextTasId: '',
        selectedStatus: 5,
        fromInvoiceIssuanceMonth: '',
        toInvoiceIssuanceMonth: '',
        selectedPaymentMethod: '',
        selectedProject: 0,
        amountBilledTotal: ''
      },
      selected: 0,
      visible: true
    }
  },
  computed: {
    checkAll: {
      get () {
        return this.checkAllFlag
      },
      set (value) {
        this.checkAllFlag = value
        this.checkChange()
      }
    },
    computedItems () {
      return this.items
    },
    computedCurrentPage () {
      return this.currentPage
    },
    computedPerPage () {
      return this.perPageGroup[this.perPageGroupId]
    },
    computedListTotalRowCount () {
      return this.listTotalRowCount
    },
    selectActions () {
      return [
        {
          value: 0,
          text: '選択してください',
          event: null,
          disabled: true
        },
        {
          value: 1,
          text: '業務報告書メール送信結果一覧',
          event: () => {
            this.downloadCsv('business_report_mail')
          },
          disabled: false
        },
        {
          value: 2,
          text: '請求書メール送信結果一覧',
          event: () => {
            this.downloadCsv('invoice_mail')
          },
          disabled: false
        },
        {
          value: 3,
          text: '請求書FAX送信結果一覧',
          event: () => {
            this.downloadCsv('invoice_fax')
          },
          disabled: false
        },
        {
          value: 4,
          text: '郵送者対象一覧',
          event: () => {
            this.downloadCsv('mail_person_target')
          },
          disabled: false
        }
      ]
    }
  },
  mounted: function () {
    // デフォルトで前月を入れる
    const nowDate = new Date()
    let nowFullYear = nowDate.getFullYear()
    let nowMonth = nowDate.getMonth()
    nowMonth++
    nowMonth = nowMonth < 10 ? '0' + nowMonth : nowMonth
    this.fromInvoiceIssuanceMonth = nowFullYear + '-' + nowMonth
    this.toInvoiceIssuanceMonth = nowFullYear + '-' + nowMonth
    this.saveTmpSearchItem()
    this.requestRecords(process.env.VUE_APP_BASE_API_URL + '/api/v1/billing/getShippingList')
  },
  methods: {
    getResponsiveColumns (cols) {
      return {
        lg: Math.round(0.1667 * cols),
        md: Math.round(0.2 * cols),
        sm: Math.round(0.25 * cols)
      }
    },
    getValidationState ({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null
    },
    onRowClicked (selectItem) {
      const checkData = this.selectItem.findIndex(item => item.business_report_and_invoice_id === selectItem.item.business_report_and_invoice_id)
      if (checkData !== -1) {
        // データが存在する場合（削除）
        this.selectItem.splice(checkData, 1)
        // this.checkAllFlag = false
      } else {
        // データが存在しない場合（追加）
        this.selectItem.push({
          'business_report_and_invoice_id': selectItem.item.business_report_and_invoice_id,
          'invoice_status': selectItem.item.invoice_status,
          'invoice_send_method_master_id': selectItem.item.invoice_send_method_master_id,
          'invoice_send_status': selectItem.item.invoice_send_status
        })
      }
      if (this.selectItem.length === this.listTotalRowCount) this.checkAllFlag = true
      this.checkJudgment()
    },
    onShowRowCountButtonClick (e, currentPage) {
      // TODO: 一旦処理を残しておく
      // this.perPageGroupId++
      // if (this.perPageGroupId >= this.perPageGroup.length) {
      //   this.perPageGroupId = 0
      // }
      const index = this.perPageGroup.indexOf(e)
      this.perPageGroupId = index
      if (currentPage) this.currentPage = currentPage
      this.currentPage = 1
      // TODO: こちらのFlagは使用していないかと思いますのでコメントアウトします
      // ページ読み込み
      // this.isChangePerPage = true

      let params = new URLSearchParams()
      params.append('limit', this.perPageGroup[this.perPageGroupId])
      params.append('tas_id', this.searchTextTasId)
      params.append('invoice_status', this.selectedStatus)
      params.append('from_invoice_made_timestamp', this.fromInvoiceIssuanceMonth)
      params.append('to_invoice_made_timestamp', this.toInvoiceIssuanceMonth)
      params.append('payment_method', this.selectedPaymentMethod)
      params.append('project_id', this.selectedProject)
      params.append('amount_billed_total', this.amountBilledTotal)

      params.append('sort_by', this.sortBy)
      params.append('sort_desc', this.sortDesc)
      this.urlParams = params.toString()
      this.getPageList()
      this.$refs.selectableTable.scrollToTop()

      // TODO: 表示件数を変更した場合は初期検索にしないので修正（一旦コメントを残しておく）
      // this.requestRecords(process.env.VUE_APP_BASE_API_URL + '/api/v1/billing/getShippingList')
    },
    selectInvoiceMadeYearMonth: function (targetMonth) {
      let tmpItemArray = []
      if (this.allItems.length === 0) return tmpItemArray
      for (let i = 0; i < this.allItems.length; i++) {
        let tmpItem = this.allItems[i]
        let tmpMonth = tmpItem['invoice_made_year_month'].slice(0, -3)
        if (tmpMonth === targetMonth) {
          tmpItemArray.push(tmpItem)
        }
      }
      return tmpItemArray
    },
    getOptionText: function (option, value) {
      for (let i = 0; i < option.length; i++) {
        if (option[i]['value'] === value) return option[i]['text']
      }
      return ''
    },
    getOptionValue: function (option, text) {
      for (let i = 0; i < option.length; i++) {
        if (option[i]['text'] === text) return option[i]['value']
      }
      return ''
    },
    shippingUpload () {
      if (this.selectItem.length === 0) return
      this.isUploadShipping = true
      this.uploadShippingIds.length = 0
      this.requestUploadShipping(0)
    },
    suspendUploadShipping () {
      this.isSuspendUploadShipping = true
    },
    requestUploadShipping ($index) {
      let url = process.env.VUE_APP_BASE_API_URL + '/api/v1/billing/uploadShippingData'
      let requestParams = {}
      requestParams['user_id'] = localStorage.user_id
      requestParams['business_report_and_invoice_id'] = this.selectItem[$index]['business_report_and_invoice_id']

      this.uploadShippingIds.push(this.selectItem[$index]['business_report_and_invoice_id'])

      this.$axios.get(url, { params: requestParams }).then(response => {
        let dlPdfBusinessReport = response.data.pdf_bi_business_report
        if (dlPdfBusinessReport != null) this.dlPdf(dlPdfBusinessReport, response.data.pdf_bi_business_report_file_name)
        let dlPdf1Bi = response.data.pdf_bi_1
        if (dlPdf1Bi != null) this.dlPdf(dlPdf1Bi, response.data.pdf_bi_1_file_name)
        let dlPdf2Bi = response.data.pdf_bi_2
        if (dlPdf2Bi != null) this.dlPdf(dlPdf2Bi, response.data.pdf_bi_2_file_name)

        if (this.isSuspendUploadShipping) {
          // 中断された
          this.isUploadShipping = false
          this.isUploadShippingFinish = true
          this.isSuspendUploadShipping = false
          this.processingCount = 1
          this.resetSelectStatus()
        } else {
          if (this.selectItem.length > $index + 1) {
            this.processingCount++
            this.requestUploadShipping($index + 1)
          } else {
            // 抜ける
            this.isUploadShipping = false
            this.isUploadShippingFinish = true
            this.processingCount = 1
            this.resetSelectStatus()

            // this.registrationAdminHeadlineNotification('5-10', this.uploadShippingIds)
            this.availablePaymentNotification(this.uploadShippingIds)
          }
        }
      }).catch(error => {
        console.log('catch', error.response)
        if (error.response == null) {
          this.showToast(this.toastType.error, '不明なエラー')
        } else {
          let errorMessage = ''
          if (error.response.status === 500) {
            errorMessage = error.response.statusText
          } else if (error.response.status === 400) {
            errorMessage = error.response.data.result_message
          } else {
            errorMessage = '[' + error.response.status + ']不明なエラー'
          }
          this.showToast(this.toastType.error, errorMessage)
        }
        this.processingCount = 1
        this.isUploadShipping = false
        this.resetSelectStatus()
        // this.registrationAdminHeadlineNotification('5-10', this.uploadShippingIds)
        this.availablePaymentNotification(this.uploadShippingIds)
        this.getPageList()
      }).finally(() => {
      })
    },
    shippingMail () {
      this.isShippingMail = true
      this.requestMailShipping(0)
    },
    suspendMailShipping () {
      this.isSuspendMailShipping = true
    },
    requestMailShipping ($index) {
      let url = process.env.VUE_APP_BASE_API_URL + '/api/v1/billing/mailShippingData'
      let requestParams = {}
      requestParams['user_id'] = localStorage.user_id
      requestParams['business_report_and_invoice_id'] = this.selectItem[$index]['business_report_and_invoice_id']

      this.$axios.get(url, { params: requestParams }).then(response => {
        if (this.isSuspendMailShipping) {
          // 中断された
          this.isShippingMail = false
          this.isShippingMailFinish = true
          this.isSuspendMailShipping = false
          this.processingCount = 1
          this.resetSelectStatus()
        } else {
          if (this.selectItem.length > $index + 1) {
            this.processingCount++
            this.requestMailShipping($index + 1)
          } else {
            // 抜ける
            this.isShippingMail = false
            this.isShippingMailFinish = true
            this.processingCount = 1
            this.resetSelectStatus()
          }
        }
      }).catch(error => {
        console.log('catch', error.response)
        if (error.response == null) {
          this.showToast(this.toastType.error, '不明なエラー')
        } else {
          let errorMessage = ''
          if (error.response.status === 500) {
            errorMessage = error.response.statusText
          } else if (error.response.status === 400) {
            errorMessage = error.response.data.result_message
          } else {
            errorMessage = '[' + error.response.status + ']不明なエラー'
          }
          this.showToast(this.toastType.error, errorMessage)
        }
        this.processingCount = 1
        this.isShippingMail = false
        this.resetSelectStatus()
      }).finally(() => {
      })
    },
    // 決済処理関連
    shippingPayment () {
      // 請求済の顧客の決済処理を開始
      // 複数選択されて決済されたらどうなる？
      // 口座、振込はページ遷移、クレジットはSMBCにリクエストするけど

      // 表示されている、請求済になっているレコード全部が対象
      let params = new URLSearchParams()
      params.append('tas_id', this.searchTextTasId)
      params.append('invoice_status', this.selectedStatus)
      params.append('from_invoice_made_timestamp', this.fromInvoiceIssuanceMonth)
      params.append('to_invoice_made_timestamp', this.toInvoiceIssuanceMonth)
      params.append('payment_method', this.selectedPaymentMethod)
      params.append('project_id', this.selectedProject)
      params.append('amount_billed_total', this.amountBilledTotal)
      params.append('sort_by', this.sortBy)
      params.append('sort_desc', this.sortDesc)

      this.isLoadingTxt = LoadingTxt.loadingTxt
      this.isLoading = true
      let url = `${process.env.VUE_APP_BASE_API_URL}/api/v1/billing/getAllId?${params.toString()}`
      this.$axios.get(url).then(response => {
        let targetData = response.data.data
        let targetUniqueIds = []
        for (let i = 0; i < targetData.length; i++) {
          if (targetData[i]['invoice_status'] === 11) {
            targetUniqueIds.push(targetData[i]['business_report_and_invoice_id'])
          }
        }

        let url = process.env.VUE_APP_BASE_API_URL + '/api/v1/billing/completePayment'
        const axiosData = {
          ids: targetUniqueIds
        }

        let config = {
          params: axiosData,
          timeout: 1000 * 60 * 3 // 3分
        }
        this.$axios.post(url, config).then(response => {
        }).catch(error => {
          const message = error.response.status + ' ' + error.response.statusText
          this.showToast(this.toastType.error, message)
        }).finally(() => {
          this.isLoading = false
          // this.registrationAdminHeadlineNotification('5-12', targetUniqueIds)
          this.beginPaymentNotification(this.uploadShippingIds)
        })
      }).catch(error => {
        this.$bvToast.toast(
          error.message,
          {
            title: ToastTextUtil.errorTitle,
            variant: 'danger',
            noAutoHide: true,
            toaster: 'b-toaster-top-center'
          }
        )
      }).finally(() => {
        this.isLoading = false
        this.resetSelectStatus()
      })
    },
    shippingReset (hasContact) {
      if (this.selectItem.length === 0) return
      this.hasContactForReset = hasContact
      this.resetItemNumberList.length = 0
      this.isResetShipping = true
      this.requestResetShipping(0)
    },
    suspendResetShipping () {
      this.isSuspendResetShipping = true
    },
    requestResetShipping ($index) {
      let url = process.env.VUE_APP_BASE_API_URL + '/api/v1/billing/resetShippingData'
      let requestParams = {}
      requestParams['user_id'] = localStorage.user_id
      requestParams['has_contact'] = this.hasContactForReset ? 1 : 0
      requestParams['business_report_and_invoice_id'] = this.selectItem[$index]['business_report_and_invoice_id']
      this.$axios.get(url, { params: requestParams }).then(response => {
        let dlPdf1Bi = response.data.pdf_bi_1
        let dlPdf2Bi = response.data.pdf_bi_2
        if (dlPdf1Bi != null) this.dlPdf(dlPdf1Bi, response.data.pdf_bi_1_file_name)
        if (dlPdf2Bi != null) this.dlPdf(dlPdf2Bi, response.data.pdf_bi_2_file_name)
        if (this.isSuspendResetShipping) {
          // 中断された
          this.isResetShipping = false
          this.isResetShippingFinish = true
          this.isSuspendResetShipping = false
          this.processingCount = 1
          this.omitResetItem()
          this.resetSelectStatus()
        } else {
          if (this.selectItem.length > $index + 1) {
            this.requestResetShipping($index + 1)
            this.processingCount++
          } else {
            // 抜ける
            this.isResetShipping = false
            this.isResetShippingFinish = true
            this.processingCount = 1
            this.omitResetItem()
            this.resetSelectStatus()
          }
        }
      }).catch(error => {
        console.log('', error)
        if (error.response == null) {
          this.showToast(this.toastType.error, '不明なエラー')
        } else {
          let errorMessage = ''
          if (error.response.status === 500) {
            errorMessage = error.response.statusText
          } else if (error.response.status === 400) {
            errorMessage = error.response.data.result_message
          } else {
            errorMessage = 'エラーコード[' + error.response.status + ']'
          }
          this.showToast(this.toastType.error, errorMessage)
        }
        this.processingCount = 1
        this.isResetShipping = false
        this.omitResetItem()
        this.resetSelectStatus()
      }).finally(() => {
      })
    },
    omitResetItem () {
      if (this.resetItemNumberList.length !== 0) {
        for (let i = 0; i < this.resetItemNumberList.length; i++) {
          let allItemIndex = this.allItems.findIndex((v) => v.business_report_and_invoice_id === this.resetItemNumberList[i])
          if (allItemIndex !== -1) {
            this.allItems.splice(allItemIndex, 1)
          }

          let itemsIndex = this.items.findIndex((v) => v.business_report_and_invoice_id === this.resetItemNumberList[i])
          if (itemsIndex !== -1) {
            this.items.splice(itemsIndex, 1)
          }
        }
      }
    },
    resetSelectStatus () {
      // 選択されている状態の削除
      this.selectItem = []
      if (this.checkAllFlag) this.checkAllFlag = false
      this.checkJudgment()
    },
    dlPdf (target, filename) {
      const arrBuffer = this.base64ToArrayBuffer(target)
      let blob = new Blob([arrBuffer], { 'type': 'application/pdf' })
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = filename
      link.click()
    },
    base64ToArrayBuffer (data) {
      const binaryString = window.atob(data)
      const binaryLen = binaryString.length
      const bytes = new Uint8Array(binaryLen)
      for (let i = 0; i < binaryLen; i++) {
        const ascii = binaryString.charCodeAt(i)
        bytes[i] = ascii
      }
      return bytes
    },
    checkShippingPaymentStatus () {
      let itemIndex = this.items.findIndex((v) => v.invoice_status === 11)
      if (itemIndex === -1) {
        this.isShippingPaymentDisabled = true
      } else {
        this.isShippingPaymentDisabled = false
      }
    },
    checkShippingMailStatus () {
      let itemIndex = this.selectItem.findIndex((v) => (v.invoice_send_method_master_id === 3 && v.invoice_send_status === 2))
      if (itemIndex === -1) {
        this.isShippingMailDisabled = true
      } else {
        this.isShippingMailDisabled = false
      }
    },
    // registrationAdminHeadlineNotification (notificationId, uniqueIdList) {
    //   // ヘッドラインへの登録
    //   if (uniqueIdList.length === 0) return

    //   const nowDate = new Date()
    //   let nowFullYear = nowDate.getFullYear()
    //   let nowMonth = nowDate.getMonth()
    //   nowMonth++
    //   nowMonth = nowMonth < 10 ? '0' + nowMonth : nowMonth

    //   let url = process.env.VUE_APP_BASE_API_URL + '/api/v1/billing/registrationAdminHeadline'
    //   let requestParams = {}
    //   requestParams['user_id'] = localStorage.user_id
    //   requestParams['notification_id'] = notificationId
    //   requestParams['target_date'] = nowFullYear + '年' + nowMonth + '月'
    //   this.$axios.get(url, { params: requestParams }).then(response => {
    //   }).catch(error => {
    //     console.log('registrationAdminHeadlineNotification error', error)
    //   }).finally(() => {
    //   })
    // },
    onCompletedShipping () {
      // 選択した顧客の請求ステータスを完了にする。
      // TODO:業務報告書、請求書ステータスを完了、入金確認ステータスを入金済、入金応対処理を完了に

      if (this.selectItem.length === 0) return
      this.isShippingCompleted = true
      this.uploadShippingIds.length = 0
      this.requestCompletedShipping(0)
    },
    requestCompletedShipping ($index) {
      let url = process.env.VUE_APP_BASE_API_URL + '/api/v1/billing/completeShippingData'
      let requestParams = {}
      requestParams['user_id'] = localStorage.user_id
      requestParams['business_report_and_invoice_id'] = this.selectItem[$index]['business_report_and_invoice_id']
      this.$axios.get(url, { params: requestParams }).then(response => {
        if (this.isSuspendShippingCompleted) {
          // 中断された
          this.isShippingCompleted = false
          this.isCompletedShippingFinish = true
          this.isSuspendShippingCompleted = false
          this.processingCount = 1
          this.resetSelectStatus()
        } else {
          if (this.selectItem.length > $index + 1) {
            this.processingCount++
            this.requestCompletedShipping($index + 1)
          } else {
            // 抜ける
            this.isShippingCompleted = false
            this.isCompletedShippingFinish = true
            this.processingCount = 1
            this.resetSelectStatus()
          }
        }
      }).catch(error => {
        console.log('catch', error.response)
        if (error.response == null) {
          this.showToast(this.toastType.error, '不明なエラー')
        } else {
          let errorMessage = ''
          if (error.response.status === 500) {
            errorMessage = error.response.statusText
          } else if (error.response.status === 400) {
            errorMessage = error.response.data.result_message
          } else {
            errorMessage = '[' + error.response.status + ']不明なエラー'
          }
          this.showToast(this.toastType.error, errorMessage)
        }
        this.processingCount = 1
        this.isShippingCompleted = false
        this.resetSelectStatus()
      }).finally(() => {
      })
    },
    suspendCompletedShipping () {
      this.isSuspendShippingCompleted = true
      this.resetSelectStatus()
    },
    downloadCsv: function (kind) {
      // 表示されているデータが対象
      // 業務報告書請求書IDを取得

      let url = process.env.VUE_APP_BASE_API_URL + '/api/v1/billing/getCsv'

      const axiosData = {
        kind: kind,
        tas_id: this.tmpSearchParams.searchTextTasId,
        invoice_status: this.tmpSearchParams.selectedStatus,
        from_invoice_made_timestamp: this.tmpSearchParams.fromInvoiceIssuanceMonth,
        to_invoice_made_timestamp: this.tmpSearchParams.toInvoiceIssuanceMonth,
        payment_method: this.tmpSearchParams.selectedPaymentMethod,
        project_id: this.tmpSearchParams.selectedProject,
        amount_billed_total: this.tmpSearchParams.amountBilledTotal,
        sort_by: this.sortBy,
        sort_desc: this.sortDesc,
        field_keys: this.fields.map(field => field.key)
      }

      let config = {
        params: axiosData,
        // responseType: 'blob',
        timeout: 1000 * 60 * 3 // 3分
      }
      this.isLoadingTxt = LoadingTxt.downloadCsvTxt
      this.isLoading = true
      this.$axios.post(url, config).then(response => {
        let fileName = ''
        if (kind === 'business_report_mail') {
          fileName = '業務報告書メール送信結果一覧.csv'
        } else if (kind === 'invoice_mail') {
          fileName = '請求書メール送信結果一覧.csv'
        } else if (kind === 'invoice_fax') {
          fileName = '請求書FAX送信結果一覧.csv'
        } else if (kind === 'mail_person_target') {
          fileName = '郵送対象者一覧.csv'
        } else if (kind === 'business_report_and_invoice_delivery_target') {
          fileName = '業務報告書と請求書発送対象者一覧.csv'
        } else {
          return
        }
        this.saveCsvFile(response, fileName)
      }).catch(error => {
        console.log(error)
        console.log(error.response)
        console.log(error.code)
        console.log(error.isAxiosError)
        const isTimeout = error.code === 'ECONNABORTED'
        const searchCountingErrorMessage = '検索結果の件数が多すぎます。検索条件をご確認ください。'
        if (isTimeout) {
          this.showToast(this.toastType.error, searchCountingErrorMessage)
          return
        }

        let message = null
        if (error.response) {
          if (error.response.status === 432) {
            message = searchCountingErrorMessage
          } else {
            message = `CSVの出力に失敗しました。Error:[${error}]`
          }
        } else {
          message = searchCountingErrorMessage
        }
        this.showToast(this.toastType.error, message)
      }).finally(() => {
        this.isLoading = false
      })
    },
    // NOTE: csv保存
    saveCsvFile (data, fileName) {
      const blob = new Blob(['\ufeff' + data.data], { type: 'text/csv' })
      if (window.navigator.msSaveBlob) {
        // NOTE: 不要なら削除予定 （IE対応用）
        window.navigator.msSaveBlob(blob, fileName)
        window.navigator.msSaveOrOpenBlob(blob, fileName)
      } else {
        // IE以外
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', fileName)
        link.click()
      }
    },
    requestRecords: function (url) {
      // 上部のボタンのリクエスト、ページネーションで分ける
      let params = new URLSearchParams()
      params.append('limit', this.perPageGroup[this.perPageGroupId])
      params.append('tas_id', this.tmpSearchParams.searchTextTasId)
      params.append('invoice_status', this.tmpSearchParams.selectedStatus)
      params.append('from_invoice_made_timestamp', this.tmpSearchParams.fromInvoiceIssuanceMonth)
      params.append('to_invoice_made_timestamp', this.tmpSearchParams.toInvoiceIssuanceMonth)
      params.append('payment_method', this.tmpSearchParams.selectedPaymentMethod)
      params.append('project_id', this.tmpSearchParams.selectedProject)
      params.append('amount_billed_total', this.tmpSearchParams.amountBilledTotal)

      params.append('sort_by', this.sortBy)
      params.append('sort_desc', this.sortDesc)

      this.isLoadingTxt = LoadingTxt.getTxt
      this.isLoading = true
      this.$axios.get(url, { params: params }).then(response => {
        this.allItems = response.data.records.data
        this.items.length = 0
        this.items = response.data.records.data

        // プロジェクトのオプション作成
        let projectList = response.data.project_data
        this.createProjectOptions(projectList)

        this.listTotalRowCount = response.data.records.total
        this.checkShippingMailStatus()

        this.urlParams = params.toString()

        // 選択状態確認
        this.checkJudgment()
        this.checkShippingPaymentStatus()
      }).catch(error => {
        let errorMessage = ''
        if (error.response.status === 500) {
          errorMessage = error.response.statusText
        } else if (error.response.status === 400) {
          errorMessage = error.response.data.result_message
        } else {
          errorMessage = '不明なエラー'
        }
        this.showToast(this.toastType.error, errorMessage)
      }).finally(() => {
        this.isLoading = false
      })
    },
    // NOTE: ページング処理
    getPageList () {
      const temporaryHolding = this.currentPage
      this.isLoadingTxt = LoadingTxt.getTxt
      this.isLoading = true
      // this.isSearchModalShow = true
      let url = `${process.env.VUE_APP_BASE_API_URL}/api/v1/billing/getShippingList?${this.urlParams}&page=${this.currentPage}`
      this.$axios.get(url).then(response => {
        this.allItems = response.data.records.data.slice()
        this.items.length = 0
        this.items = response.data.records.data.slice()

        this.listTotalRowCount = response.data.records.total
        // 選択状態確認
        this.checkJudgment()
        this.checkShippingPaymentStatus()
        this.currentPage = 1
      }).catch(error => {
        let errorMessage = ''
        console.log('error', error)
        if (error.response.status === 500) {
          errorMessage = error.response.statusText
        } else if (error.response.status === 400) {
          errorMessage = error.response.data.result_message
        } else {
          errorMessage = '不明なエラー'
        }
        this.showToast(this.toastType.error, errorMessage)
      }).finally(() => {
        this.isLoading = false
        this.currentPage = temporaryHolding
      })
    },
    // NOTE: ソート項目変更時の処理
    sortChanged (e) {
      console.log('NOTE', e)
      this.currentPage = 1
      this.sortBy = e.sortBy
      this.sortDesc = e.sortDesc
      if (this.currentPage === 1) {
        this.requestRecords(process.env.VUE_APP_BASE_API_URL + '/api/v1/billing/getShippingList')
      } else {
        let params = new URLSearchParams()
        params.append('limit', this.perPageGroup[this.perPageGroupId])
        params.append('tas_id', this.tmpSearchParams.searchTextTasId)
        params.append('invoice_status', this.tmpSearchParams.selectedStatus)
        params.append('from_invoice_made_timestamp', this.tmpSearchParams.fromInvoiceIssuanceMonth)
        params.append('to_invoice_made_timestamp', this.tmpSearchParams.toInvoiceIssuanceMonth)
        params.append('payment_method', this.tmpSearchParams.selectedPaymentMethod)
        params.append('project_id', this.tmpSearchParams.selectedProject)
        params.append('amount_billed_total', this.tmpSearchParams.amountBilledTotal)

        params.append('sort_by', this.sortBy)
        params.append('sort_desc', this.sortDesc)
        this.urlParams = params.toString()
        this.getPageList()
      }
      this.$refs.selectableTable.scrollToTop()
    },

    // NOTE: 請求書発行月のクリア処理
    invoiceIssuanceMonthClear () {
      this.fromInvoiceIssuanceMonth = ''
      this.toInvoiceIssuanceMonth = ''
      this.$refs['from-invoice-issuance-month'].$el.value = ''
      this.$refs['to-invoice-issuance-month'].$el.value = ''
      this.$refs.fromInvoiceIssuanceMonth.reset()
      this.$refs.toInvoiceIssuanceMonth.reset()
    },
    load () {
      this.currentPage = 1
      this.perPageGroupId = this.perPageGroup.indexOf(20)
      this.sortBy = 'invoice_made_year_month'
      this.sortDesc = true
      this.checkAllFlag = false
      this.$refs.selectableTable.clear()
      this.selectItem = []
      if (this.checkAllFlag) {
        this.checkAllFlag = false
        this.selectItem = []
      }
      const GET_VALID = this.$refs.validationObserver.validate()
      Promise.all([ GET_VALID ]).then(res => {
        if (res[0]) {
          this.saveTmpSearchItem()
          this.requestRecords(process.env.VUE_APP_BASE_API_URL + '/api/v1/billing/getShippingList')
          this.$refs.selectableTable.scrollToTop()
          // this.checkJudgment()
        } else {
          this.isValidAlertMessage = []
          const validErrorObj = {}
          validErrorObj['itemName'] = '検索'
          validErrorObj['itemList'] = []
          const validError = this.$refs.validationObserver.errors
          Object.keys(validError).forEach(key => {
            if (validError[key].length !== 0) {
              validErrorObj['itemList'].push(validError[key][0])
            }
          })
          this.isValidAlertMessage.push(validErrorObj)
          this.isValidAlert = true
          return true
        }
      }).catch(error => {
        // NOTE: エラーになることはないと思うが一旦おまじない
        this.showToast(this.toastType.error, error.message)
      })
    },
    showToast (type, message) {
      switch (type) {
        case this.toastType.error:
          this.$bvToast.toast(message, { title: ToastTextUtil.errorTitle, variant: 'danger', noAutoHide: true, toaster: 'b-toaster-top-center' })
          break
        case this.toastType.warning:
          this.$bvToast.toast(message, { title: ToastTextUtil.warningTitle, variant: 'warning', toaster: 'b-toaster-top-center' })
          break
        case this.toastType.info:
          this.$bvToast.toast(message, { title: ToastTextUtil.infoTitle, variant: 'info', toaster: 'b-toaster-top-center' })
          break
        case this.toastType.success:
          this.$bvToast.toast(message, { title: ToastTextUtil.successTitle, variant: 'success', toaster: 'b-toaster-top-center' })
          break
      }
    },
    // NOTE: バリデートアラートのクローズ
    alertClose () {
      this.isValidAlert = false
    },
    createProjectOptions (tables) {
      this.assumeProjectOption.length = 0

      let optionItem = {}
      optionItem['text'] = '未設定'
      optionItem['value'] = 0
      this.assumeProjectOption.push(optionItem)

      for (let cnt = 0; cnt < tables.length; cnt++) {
        let item = tables[cnt]
        if (item != null) {
          let optionItem = {}
          optionItem['text'] = item['name']
          optionItem['value'] = item['project_master_id']
          this.assumeProjectOption.push(optionItem)
        }
      }
    },
    // NOTE: 検索項目のクリア
    searchItemClear () {
      this.searchTextTasId = ''
      this.selectedStatus = 0
      this.selectedPaymentMethod = 0
      this.selectedProject = 0
      this.amountBilledTotal = ''
      this.invoiceIssuanceMonthClear()
    },
    // NOTE: ページング再検索
    pagingSearchingAgain (e) {
      this.currentPage = e
      this.getPageList()
      this.$refs.selectableTable.scrollToTop()
    },
    // NOTE: チェックボックス判定
    checkChange () {
      if (this.checkAllFlag) {
        this.isLoadingTxt = LoadingTxt.getTxt
        this.isLoading = true

        let params = new URLSearchParams()
        params.append('tas_id', this.tmpSearchParams.searchTextTasId)
        params.append('invoice_status', this.tmpSearchParams.selectedStatus)
        params.append('from_invoice_made_timestamp', this.tmpSearchParams.fromInvoiceIssuanceMonth)
        params.append('to_invoice_made_timestamp', this.tmpSearchParams.toInvoiceIssuanceMonth)
        params.append('payment_method', this.tmpSearchParams.selectedPaymentMethod)
        params.append('project_id', this.tmpSearchParams.selectedProject)
        params.append('amount_billed_total', this.tmpSearchParams.amountBilledTotal)
        params.append('sort_by', this.sortBy)
        params.append('sort_desc', this.sortDesc)
        let url = `${process.env.VUE_APP_BASE_API_URL}/api/v1/billing/getAllId?${params.toString()}`
        this.$axios.get(url).then(response => {
          this.selectItem = response.data.data
          this.checkJudgment()
        }).catch(error => {
          this.$bvToast.toast(
            error.message,
            {
              title: ToastTextUtil.errorTitle,
              variant: 'danger',
              noAutoHide: true,
              toaster: 'b-toaster-top-center'
            }
          )
          this.checkAllFlag = false
        }).finally(() => {
          this.isLoading = false
        })
      } else {
        this.selectItem = []
        this.checkJudgment()
      }
      this.checkAllFlag = this.checkAllFlag
    },

    // NOTE: チェック判定
    checkJudgment () {
      this.$refs.selectableTable.clearSelected()
      for (let i = 0; i < this.items.length; i++) {
        const check = this.selectItem.some(item => item.business_report_and_invoice_id === this.items[i].business_report_and_invoice_id)

        if (check) {
          this.$refs.selectableTable.select(this.items[i], i)
        }
      }
      this.checkSelectedItems()
    },
    checkSelectedItems () {
      if (this.selectItem.length > 0) {
        this.isShippingResetDisabled = false
        this.isShippingUploadDisabled = false
        this.isShippingCompletedDisabled = false
        this.isShippingBilledDisabled = false
      } else {
        this.isShippingResetDisabled = true
        this.isShippingUploadDisabled = true
        this.isShippingCompletedDisabled = true
        this.isShippingBilledDisabled = true
      }
      this.checkShippingMailStatus()
    },
    getEarmarkingYearMonthData (value) {
      if (!value) {
        return ''
      } else {
        return value.slice(0, -3)
      }
    },
    onBilledShipping () {
      // 選択した顧客の請求ステータスを請求済にする。
      if (this.selectItem.length === 0) return
      this.isShippingBilled = true
      this.uploadShippingIds.length = 0
      this.requestBilledShipping(0)
    },
    requestBilledShipping ($index) {
      let url = process.env.VUE_APP_BASE_API_URL + '/api/v1/billing/billedShippingData'
      let requestParams = {}
      requestParams['user_id'] = localStorage.user_id
      requestParams['business_report_and_invoice_id'] = this.selectItem[$index]['business_report_and_invoice_id']
      this.$axios.get(url, { params: requestParams }).then(response => {
        if (this.isSuspendShippingBilled) {
          // 中断された
          this.isShippingBilled = false
          this.isCompletedBilledFinish = true
          this.isSuspendShippingBilled = false
          this.processingCount = 1
          this.resetSelectStatus()
        } else {
          if (this.selectItem.length > $index + 1) {
            this.processingCount++
            this.requestBilledShipping($index + 1)
          } else {
            // 抜ける
            this.isShippingBilled = false
            this.isCompletedBilledFinish = true
            this.processingCount = 1
            this.resetSelectStatus()
          }
        }
      }).catch(error => {
        console.log('catch', error.response)
        if (error.response == null) {
          this.showToast(this.toastType.error, '不明なエラー')
        } else {
          let errorMessage = ''
          if (error.response.status === 500) {
            errorMessage = error.response.statusText
          } else if (error.response.status === 400) {
            errorMessage = error.response.data.result_message
          } else {
            errorMessage = '[' + error.response.status + ']不明なエラー'
          }
          this.showToast(this.toastType.error, errorMessage)
        }
        this.processingCount = 1
        this.isShippingBilled = false
        this.resetSelectStatus()
      }).finally(() => {
      })
    },
    suspendBilledShipping () {
      this.isSuspendShippingBilled = true
      this.resetSelectStatus()
    },
    refreshRowsSelected () {
      this.$refs.selectableTable.clearSelected()
      for (let i = 0; i < this.items.length; i++) {
        const check = this.tmpSelectedItem.some(item => item.ID === this.items[i].ID)
        if (check) {
          this.$refs.selectableTable.select(this.items[i], i)
        }
      }
      this.checkJudgement()
    },
    saveTmpSearchItem () {
      this.tmpSearchParams.searchTextTasId = this.searchTextTasId
      this.tmpSearchParams.selectedStatus = this.selectedStatus
      this.tmpSearchParams.fromInvoiceIssuanceMonth = this.fromInvoiceIssuanceMonth
      this.tmpSearchParams.toInvoiceIssuanceMonth = this.toInvoiceIssuanceMonth
      this.tmpSearchParams.selectedPaymentMethod = this.selectedPaymentMethod
      this.tmpSearchParams.selectedProject = this.selectedProject
      this.tmpSearchParams.amountBilledTotal = this.amountBilledTotal
    },
    getAmountBilledTotal (value) {
      if (!value) return ''

      return value.toLocaleString()
    },
    changeSelectAction (value) {
      this.selected = value
    }
  }
}
</script>

<style lang="scss">
#modal-shipping-reset,
#modal-shipping-reset-no-contact,
#modal-shipping-completed,
#modal-shipping-billed,
#modal-shipping-upload {
  .modal-footer {
    padding-top: 0px;
  }
}
</style>

<style lang="scss" scoped>
.filter-label {
  margin-bottom: 0.375rem;
}

.filter-group {
  margin-top: 0.75rem!important;
}
.custom-width {
  width: 231px !important;
}
</style>
